export default {
  title: 'Commission Details',
  tabs: {
    trade: 'Trade Commission',
    follow: 'Copy Commission',
    pamm: 'PAMM Commission',
  },
  filter: {
    keywords: 'Order No. / Commission User Name / ID / Email',
    receiverName: 'Receiver Name',
    dataRange: 'Data Range',
    tradeType: 'Trade Type',
    tradeSymbol: 'Symbol',
    settlementStatus: 'Settlement Status',
    commissionTimeStart: 'Commission Time',
    commissionTimeEnd: 'Commission Time',
    closeTimeStart: 'Close Time',
    closeTimeEnd: 'Close Time',
    search: 'Search',
    reset: 'Reset',
  },
  options: {
    dataRange: {
      all: 'All',
      self: 'Self',
      directSub: 'Direct Subordinate',
      indirectSub: 'Indirect Subordinate',
    },
    tradeType: {
      buy: 'Buy',
      sell: 'Sell',
    },
    settlementStatus: {
      settled: 'Settled',
      pending: 'Pending',
    },
  },
  stats: {
    customerCount: 'Customers',
    totalTradeAndUsd: 'Total Trades / million USD',
    totalCommission: 'Total Commission',
  },
  table: {
    lotUnit: 'Lot',
    columns: {
      orderNo: 'Order No.',
      commUserName: 'Commission User Name',
      commUserEmail: 'Commission User Email',
      receiverUserName: 'Receiver Name',
      tradeType: 'Trade Type',
      tradeVolumeTitle: 'Volume (lots) / million USD',
      tradeSymbol: 'Symbol',
      openPrice: 'Open Price',
      closePrice: 'Close Price',
      openTime: 'Open Time',
      closeTime: 'Close Time',
      commissionTime: 'Commission Time',
      commissionType: 'Commission Type',
      commissionGroup: 'Commission Group',
      commissionAmount: 'Commission Amount',
      commissionFormula: 'Formula',
      status: 'Status',
      remark: 'Remark',
    },
    commissionTypeMap: {
      internal: 'Internal',
      external: 'External',
      referral: 'Referral',
    },
    statusMap: {
      settled: 'Settled',
      pending: 'Pending',
    },
  },
}